module.exports = __webpack_public_path__ + "static/img/30020 (2).f6aa945.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30020 (2).webp
// module id = HyOF
// module chunks = 14